import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IEarningFormikValues } from '@/pages/Partners/pages/Earnings/Rescue/types';

interface IFilter {
  date: string; // YYYY-MM
}

export interface EarningsState {
  steps: number;
  filter: IFilter;
  totalBalance: number;
  formValues: IEarningFormikValues;
}

const initialValueFilterDate = new Date().toISOString().slice(0, 7);

const initialState: EarningsState = {
  steps: 1,
  filter: {
    date: initialValueFilterDate,
  },
  totalBalance: 0,
  formValues: {} as IEarningFormikValues,
};

const earningsSlice = createSlice({
  name: 'earnings',
  initialState,
  reducers: {
    setSteps(state, action: PayloadAction<number>) {
      state.steps = action.payload;
    },
    nextStep(state) {
      state.steps += 1;
    },
    prevStep(state) {
      state.steps -= 1;
    },
    setFilter(state, action: PayloadAction<IFilter>) {
      state.filter = action.payload;
    },
    setTotalBalance(state, action: PayloadAction<number>) {
      state.totalBalance = action.payload;
    },
    setFormValues(state, action: PayloadAction<IEarningFormikValues>) {
      state.formValues = action.payload;
    },
    resetEarningsState(state) {
      state.steps = 1;
      state.filter = { date: initialValueFilterDate };
      state.totalBalance = 0;
      state.formValues = {} as IEarningFormikValues;
    },
  },
});

export const {
  setSteps,
  nextStep,
  prevStep,
  setFilter,
  setTotalBalance,
  setFormValues,
  resetEarningsState,
} = earningsSlice.actions;

export default earningsSlice.reducer;
